<template>
  <d-card class="card-small">

    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
      <div class="block-handle"></div>
    </d-card-header>

    <d-card-body class="p-0">
      <div class="table-overflow">
        <quotation-table :quotations="quotations.list"></quotation-table>
      </div>

    </d-card-body>

    <d-card-footer>
      <pagination :total-items="quotations.total_items" :pagination.sync="pagination"></pagination>
    </d-card-footer>

  </d-card>
</template>

<script>
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import QuotationTable from '_modules/quotation/components/QuotationListTable.vue';
import DashboardService from '_services/rest/modules/dashboard';

export default {
  name: 'dashboard-last-quotation',
  components: {
    Pagination,
    QuotationTable,
  },
  data() {
    return {
      title: 'Orçamentos vencidos',
      quotations: {
        list: [],
        total_items: 0,
      },
      pagination: {
        search: '',
        skip: 0,
        take: 5,
        page: 1,
      },
    };
  },
  methods: {
    getQuotations() {
      DashboardService.getQuotationsDashboardAlerts(this.pagination)
        .then(response => {
          this.quotations = response;
        });
    },
  },
  mounted() {
    Events.$on('update:pagination', pagination => {
      this.pagination.page = pagination.page;
      this.getQuotations();
    });
    this.getQuotations();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  cursor: pointer;
}
.row-total,
.row-status {
  width: 15%;
}
.row-name {
  width: 70%;
}
</style>

